import React, { useMemo } from 'react';
import { JRCDate } from 'components/JRCDate/JRCDate';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { isToday, isTomorrow } from 'utils/utils.date';

export const UIDate = styled.ul`
    display: flex;
    flex-direction: row;
`;

export const JRCWidgetLuccaAbsenceStatus = ({ datetime }: { datetime: string }) => {
    const statusIsToday = isToday(datetime);
    const statusIsTomorrow = isTomorrow(datetime);

    const message = useMemo(() => {
        if (statusIsToday) return 'WIDGET_Lucca_Absent_Until_Today';
        if (statusIsTomorrow) return 'WIDGET_Lucca_Absent_Until_Tomorrow';
        return 'WIDGET_Lucca_Absent_Until';
    }, [statusIsToday, statusIsTomorrow]);
    const format = useMemo(() => {
        if (statusIsToday || statusIsTomorrow) return 'time';
        return 'date-time';
    }, [statusIsToday, statusIsTomorrow]);

    return (
        <UIDate>
            <FormattedMessage id={message} />
            &nbsp;
            <JRCDate date={datetime} smartDate={false} format={format} />
        </UIDate>
    );
};
